import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const UNIT_PATH = "/unit/v1";

export const getUnitApi = async (params) => await getRequest(UNIT_PATH, params);

export const getUnitByIdApi = async (id) =>
  await getRequest(`${UNIT_PATH}/${id}`);

export const addUnitApi = async (data) => await postRequest(UNIT_PATH, data);

export const updateUnitApi = async (id, data) => await putRequest(`${UNIT_PATH}/${id}`, data);

export const deleteUnitByIdApi = async (id) => {
  console.log(`🗑️🗑️🗑️ === DELETE UNIT API CALLED === 🗑️🗑️🗑️`);
  console.log(`📍 Unit ID: ${id} (type: ${typeof id})`);
  console.log(`📍 Request URL: ${UNIT_PATH}/${id}`);
  console.log(`📍 Current timestamp: ${new Date().toISOString()}`);
  
  try {
    console.log(`🔄 About to make DELETE request...`);
    const result = await deleteRequest(`${UNIT_PATH}/${id}`);
    console.log(`📤 DELETE request sent successfully`);
    console.log(`📤 Response status:`, result?.status);
    console.log(`📤 Response code:`, result?.code);
    console.log(`📤 Response message:`, result?.message);
    console.log(`📤 Full response:`, JSON.stringify(result, null, 2));
    return result;
  } catch (error) {
    console.error(`❌❌❌ deleteUnitByIdApi error:`, error);
    console.error(`❌ Error details:`, error.response?.data);
    throw error;
  }
};
